import React, { useState } from "react";
import { toast } from "sonner";
import { finApi } from "@/lib/financeApi";
import { field } from "@/components/nds/windows/finance/parts";

/** Bulk transitions for checked rows: runs each record's own action endpoint, one by one. */
export function BulkBar({ cfg, records, picked, setPicked, onDone }) {
  const [mode, setMode] = useState(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const rows = records.filter((r) => picked.includes(r.id));
  const acts = cfg.actions.filter((a) => a.bulk);
  const run = async (a) => {
    const ok = rows.filter((r) => a.from.includes(r.status));
    if (a.note && !a.optionalNote && !note.trim()) { toast.error("Notes are required"); return; }
    if (ok.length > 20 && !window.confirm(`${a.label} ${ok.length} ${cfg.plural} at once?`)) return;
    setBusy(true);
    let done = 0;
    for (const r of ok) {
      try { await (cfg.client || finApi).patch(`${cfg.api}/${r.id}/${a.name}`, { note }); done += 1; } catch { /* counted below */ }
    }
    setBusy(false);
    const failed = ok.length - done;
    const na = rows.length - ok.length;
    (done ? toast.success : toast.error)(`${a.label}: ${done} ${cfg.plural}${na ? ` · ${na} already ${a.name === "close" ? "closed" : "done"}` : ""}${failed ? ` · ${failed} failed` : ""}`);
    setMode(null); setNote(""); setPicked([]); onDone();
  };
  if (!rows.length) return null;
  const a = acts.find((x) => x.name === mode);
  return (
    <div data-testid={`${cfg.testid}-bulk-bar`} className="px-5 py-3 border-b border-nex-gold/30 bg-nex-gold/5 flex flex-wrap items-center gap-2">
      <span data-testid={`${cfg.testid}-bulk-count`} className="font-mono text-[11px] uppercase tracking-[0.15em] text-nex-gold">{rows.length} selected</span>
      {!a && acts.map((x) => {
        const n = rows.filter((r) => x.from.includes(r.status)).length;
        return <button key={x.name} type="button" disabled={!n || busy} onClick={() => setMode(x.name)} data-testid={`${cfg.testid}-bulk-${x.name}`}
          className="px-3 py-1 border border-white/15 text-xs text-nex-silver hover:border-nex-gold disabled:opacity-40">{x.label} {n}</button>;
      })}
      {a && <>
        <input autoFocus value={note} onChange={(e) => setNote(e.target.value)} placeholder={a.placeholder} data-testid={`${cfg.testid}-bulk-note`} className={`${field} flex-1 min-w-[200px]`} />
        <button type="button" disabled={busy} onClick={() => run(a)} data-testid={`${cfg.testid}-bulk-confirm`} className="px-3 py-1 bg-nex-gold text-black text-xs font-semibold disabled:opacity-50">{busy ? "Working…" : `${a.label} ${rows.filter((r) => a.from.includes(r.status)).length}`}</button>
        <button type="button" onClick={() => { setMode(null); setNote(""); }} data-testid={`${cfg.testid}-bulk-cancel`} className="text-xs text-nex-muted">Cancel</button>
      </>}
      <button type="button" onClick={() => setPicked([])} data-testid={`${cfg.testid}-bulk-clear`} className="ml-auto text-xs text-nex-muted hover:text-nex-gold">Clear</button>
    </div>
  );
}
